import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';

import InventoryStats from 'components/stats/InventoryStats';
//import InventoryTotalOrdersCard from 'components/cards/InventoryTotalOrdersCard';
import InventoryTotalInventoryCard from 'components/cards/InventoryTotalInventoryCard';
//import InventoryInventoryCard from 'components/cards/InventoryInventoryCard';
import InventoryTopOrderItemsCard from 'components/cards/InventoryTopOrderItemsCard';
import InventoryLastInventoryCard from 'components/cards/InventoryLastInventoryCard';
//import InventoryLatestOrdersTable from 'components/tables/InventoryLatestOrdersTable';
import { Alert, Spinner } from 'react-bootstrap';
import { getDashboardJobs, getDashboardDrills } from 'api/api';
import { setNavigate } from '../../../helpers/navigation';

const InventoryDashBoard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drills, setDrills] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [drillChart, setDrillChart] = useState(null);

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem('drillwurks_token');
    if (token === null) navigate('/sign-in');
  }, []);

  useEffect(() => {
    loadJobsData();
    loadDrillsData();
  }, []);

  const loadJobsData = () => {
    setError([]);
    setLoading(true);
    getDashboardJobs()
      .then(response => {
        setData(response.data.data);
        console.log(response.data.data);
        const jobs = response.data.data;

        const jobsArray = Object.entries(jobs)
          .filter(([key]) => key !== 'all_jobs')
          .map(([key, value]) => {
            const name = capitalizeFirstLetter(key.replace(/_/g, ' '));
            const percentage = ((value / jobs.all_jobs) * 100).toFixed(2);
            return {
              name,
              percentage: `${percentage}%`,
              total: value
            };
          });

        setJobs(jobsArray);

        // setLastCheckOutData(response.data.data.last_checkedouts);
      })
      .catch(err => {
        try {
          if (err.response.status === 401) {
            navigate('/sign-in');
          }

          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadDrillsData = () => {
    setError([]);
    setLoading(true);
    getDashboardDrills()
      .then(response => {
        console.log(response.data.data);

        setDrillChart(response.data.data);

        const drills = Object.entries(response.data.data).map(
          ([key, value]) => ({
            status: key.toUpperCase(),
            total: value
          })
        );

        setDrills(drills);
      })
      .catch(err => {
        try {
          if (err.response.status === 401) {
            navigate('/sign-in');
          }

          setError(err.response.data.errors);
        } catch (ex) {
          console.log(ex);
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const capitalizeFirstLetter = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          <Spinner animation="border" role="status"></Spinner>
        </div>
      ) : (
        <>
          <div className="pb-5">
            <div>
              {error &&
                error.map((e, index) => (
                  <Alert variant="soft-danger" key={index}>
                    {e}
                  </Alert>
                ))}
            </div>

            <Row className="g-4">
              <Col xs={12} xxl={6}>
                <div className="mb-8">
                  <h2 className="mb-2">Drillwurks Management Dashboard</h2>
                  <h5 className="text-700 fw-semi-bold"></h5>
                </div>
                <InventoryStats
                  all_jobs={data.length === 0 ? 0 : data.all_jobs}
                  completed_jobs={data.length === 0 ? 0 : data.completed_jobs}
                  inprogress_jobs={data.length === 0 ? 0 : data.inprogress_jobs}
                />

                <InventoryTotalInventoryCard inventory={drills && drills} />
              </Col>
              <Col xs={12} xxl={6}>
                <Row className="g-3">
                  {/* <Col xs={12} md={6}>
                    <InventoryTotalOrdersCard
                      orders={
                        data &&
                        data.checkedout_by_date &&
                        data.checkedout_by_date
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <InventoryInventoryCard
                      inventory={
                        data && data.inventory_by_date && data.inventory_by_date
                      }
                    />
                  </Col> */}
                  <Col xs={12} md={6}>
                    <InventoryTopOrderItemsCard jobItems={jobs && jobs} />
                  </Col>
                  <Col xs={12} md={6}>
                    <InventoryLastInventoryCard
                      lastInventoryLog={drillChart && drillChart}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          {/* <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white pt-7 border-y border-300">
            <InventoryLatestOrdersTable
              latestOrders={lastCheckOutsData && lastCheckOutsData}
            />
          </div> */}
        </>
      )}
    </>
  );
};

export default InventoryDashBoard;
